import React, { useState, useEffect } from "react";
import TourContext from "./tourContext";
import { APP_PREFIX_PATH } from "configs/AppConfig";

function TourProvider({ children }) {
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);
  const [isTourVisit, setIsTourVisit] = useState(false);
  const [tutorialConfig, setTutoialConfig] = useState({});
  const [isRedirectToDashboard, setIsRedirectToDashboard] = useState(false);
  const handleTourClose = () => {
    setIsTourOpen(false);
    setStepIndex(0);
    setIsTourVisit(false);
  };

  const handleRedirectToDashboard = () => {
    window.location.href = `${APP_PREFIX_PATH}/dashboards/default`;
    setIsRedirectToDashboard(false);
  };

  return (
    <TourContext.Provider
      value={{
        isTourOpen,
        setIsTourOpen,
        stepIndex,
        setStepIndex,
        handleTourClose,
        isTourVisit,
        setIsTourVisit,
        tutorialConfig,
        setTutoialConfig,
        isRedirectToDashboard,
        setIsRedirectToDashboard,
        handleRedirectToDashboard,
      }}
    >
      {children}
    </TourContext.Provider>
  );
}

export default TourProvider;
